import { FormlyFieldConfigMap } from './formly-field-config.map';
import { FormlyUtil } from '../formly.util';
import {ItemAttributeType} from '@emm/core/models/enums';
import { Attribute } from '@emm/core/models/attribute.model';

const attributesPlaceHolder = 'Search for an Attribute';
const filters = [
    { tag: 'name', value: 'Name', type: ItemAttributeType.Text },
    { tag: 'locked', value: 'Locked', type: ItemAttributeType.Boolean },
    { tag: 'tag', value: 'Tag', type: ItemAttributeType.Text },
    { tag: 'jsonProperty', value: 'JSON Attribute Name', type: ItemAttributeType.Text }
];

const fieldMap = {

    [ItemAttributeType.Text]: (item: { tag: string; value: string; type: ItemAttributeType }) => ({
        key: item.tag,
        templateOptions: {
            label: item.value,
            maxLength: 512,
            placeholder: attributesPlaceHolder
        },
        type: 'input',
        wrappers: ['form-field-filter']
    }),

    [ItemAttributeType.Boolean]: (item: { tag: string; value: string; type: ItemAttributeType }) => ({
        key: item.tag,
        templateOptions: {
            label: item.value,
            options: [...FormlyUtil.getBooleanList(true)]
        },
        type: 'select',
        wrappers: ['form-field-filter']
    }),

    [ItemAttributeType.Number]: (item: { tag: string; value: string; type: ItemAttributeType }) => ({
        key: item.tag,
        templateOptions: {
            label: item.value,
            maxLength: 512,
            placeholder: attributesPlaceHolder,
            type: 'number'
        },
        type: 'input',
        wrappers: ['form-field-filter']
    })

};

export const attributesFilterFieldMap: FormlyFieldConfigMap<Attribute> = filters.reduce(
    (acc, cur) => {
        return {
            ...acc,
            [cur.tag]: fieldMap[cur.type](cur)
        };
    },
    {}
);
